import clsx from 'clsx';

export function DisabledInput({
  className,
  value,
  label,
  inputClass,
}: {
  className?: string;
  value?: string | number | null;
  label?: string;
  inputClass?: string;
}) {
  return (
    <fieldset className={clsx('fieldset', className)}>
      {label && <legend className="fieldset-legend">{label}</legend>}
      <input disabled className={clsx('input w-full', inputClass)} value={value ?? ''} />
    </fieldset>
  );
}
